var _excluded = ["label", "universityLogo", "className", "id"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import classNames from "classnames";
import styles from "./TagUniversity.module.css";
export var TagUniversity = function TagUniversity(_ref) {
  var label = _ref.label,
    universityLogo = _ref.universityLogo,
    className = _ref.className,
    id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: classNames(styles["jds-TagUniversity"], !universityLogo && styles["jds-TagUniversity--withoutLogo"], className),
    "data-testid": "jds-TagUniversity".concat(id ? "-".concat(id) : ""),
    title: label
  }), !!universityLogo && /*#__PURE__*/React.createElement("img", {
    className: styles["jds-TagUniversity__logo"],
    src: universityLogo,
    alt: "logo ".concat(label)
  }), label);
};